import {requirePermission} from '@/modules/auth/permissions'
import {AppLayout} from '@/modules/layout/app-layout/components/app-layout'
import {createFileRoute} from '@tanstack/react-router'

export const Route = createFileRoute('/production')({
  beforeLoad: requirePermission('production.access'),
  component: ProductionLayout,
})

function ProductionLayout() {
  return <AppLayout hideSideDrawer />
}
